import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import cx from 'classnames';
import FormLabel from './FormLabel';
import FormFooter from './FormFooter';
import { generateUUID } from '../helpers/utility';
import { config } from '../helpers/config';

var Select = function Select(_ref) {
  var _cx;

  var className = _ref.className,
      explanationMessage = _ref.explanationMessage,
      label = _ref.label,
      multiple = _ref.multiple,
      name = _ref.name,
      options = _ref.options,
      onChange = _ref.onChange,
      required = _ref.required,
      validationMessage = _ref.validationMessage,
      opts = _objectWithoutPropertiesLoose(_ref, ["className", "explanationMessage", "label", "multiple", "name", "options", "onChange", "required", "validationMessage"]);

  var id = name + "-" + generateUUID();

  var handleOnChange = function handleOnChange(_ref2) {
    var _ref2$target = _ref2.target,
        fieldName = _ref2$target.name,
        fieldValue = _ref2$target.value;
    var selectedValue = parseInt(fieldValue, 10) ? parseInt(fieldValue, 10) : fieldValue;
    onChange(fieldName, selectedValue);
  };

  var classes = cx('form-group', className, (_cx = {}, _cx[config.classes.notValid] = validationMessage, _cx[config.classes.required] = required, _cx));
  var selectClasses = cx('form-select', {
    'form-select--multiple': multiple
  });

  var renderOpts = function renderOpts(option) {
    // If the option has options as well we're in an `<optgroup>`
    if (option.options) {
      return React.createElement("optgroup", {
        key: option.value,
        label: option.label
      }, option.options.map(function (childOption) {
        return React.createElement("option", {
          key: childOption.value,
          value: childOption.value
        }, childOption.label);
      }));
    } // We're in a default single-level `<option>`


    return React.createElement("option", {
      key: option.value,
      value: option.value
    }, option.label);
  };

  return React.createElement("div", {
    className: classes
  }, React.createElement(FormLabel, {
    id: id
  }, label), React.createElement("div", {
    className: selectClasses
  }, React.createElement("select", Object.assign({
    id: id,
    name: name,
    onChange: handleOnChange,
    multiple: multiple
  }, opts), options.map(renderOpts))), React.createElement(FormFooter, {
    explanationMessage: explanationMessage,
    validationMessage: validationMessage
  }));
};

export default Select;